import { useState } from 'react';
import { productCategories, products, getProductsByCategoryUrl } from '@/mocks/products';
import ProductCard from '@/components/feature/ProductCard';
import { useLang } from '@/hooks/useLang';

export function HomeProductsSection() {
  const [activeCategory, setActiveCategory] = useState<string>('shoes');
  const lang = useLang();

  const categoriesWithProducts = productCategories.filter((cat) =>
    products.some((p) => p.categoryId === cat.id)
  );

  const activeProducts = products.filter(
    (p) => p.categoryId === activeCategory
  ).slice(0, 4);

  const activeCategoryUrl = getProductsByCategoryUrl(activeCategory);

  return (
    <section id="products" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 max-w-3xl mx-auto">
          <span className="text-primary-700 text-sm font-bold uppercase tracking-wider mb-2 block">
            Product Catalog
          </span>
          <h2 className="text-foreground-900 text-2xl md:text-4xl font-bold mb-4">
            Browse Products from AllChinaBuy Spreadsheet
          </h2>
          <p className="text-foreground-700 text-base md:text-lg leading-relaxed">
            Explore curated product selections across categories. Click any item to view details and purchase on the main platform.
          </p>
        </div>

        {/* Category tabs */}
        <div className="flex flex-wrap gap-2 mb-8 justify-center overflow-x-auto pb-2 scrollbar-hide">
          {categoriesWithProducts.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`flex items-center gap-1.5 px-4 py-2.5 rounded-full text-sm font-semibold whitespace-nowrap transition-all duration-200 border ${
                activeCategory === cat.id
                  ? 'bg-primary-500 text-white border-primary-500 shadow-sm'
                  : 'bg-background-50 text-foreground-700 border-background-200 hover:bg-primary-50 hover:text-primary-700 hover:border-primary-200'
              }`}
            >
              <i className={`${cat.icon} text-sm`}></i>
              {cat.name}
            </button>
          ))}
        </div>

        {/* Product grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-8">
          {activeProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {/* View all button */}
        <div className="text-center">
          <a
            href={activeCategoryUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 text-white font-bold px-8 py-3 rounded-md text-base hover:bg-primary-600 transition-all duration-200 hover:shadow-md whitespace-nowrap"
          >
            View All {categoriesWithProducts.find(c => c.id === activeCategory)?.name}
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        {/* View full catalog CTA */}
        <div className="mt-8 text-center">
          <a
            href={`/${lang}/products/`}
            className="inline-flex items-center gap-2 text-primary-700 font-semibold text-sm hover:text-primary-900 transition-colors whitespace-nowrap"
          >
            Browse Full Product Catalog
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}

export default HomeProductsSection;